import { useApiRequestOptions } from "../hooks";

export const useDashboardApi = () => useApiRequestOptions({
  uri: 'dashboard'
}, []);

export const useAccountOverviewApi = () => useApiRequestOptions({
  uri: 'account_overview'
}, []);
